import React from 'react';
import { useState, useEffect } from 'react';
import CustomInputValue from '../../../components/Elements/inputWithValue/customInputValue';
import ChooseUserOption from '../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import ApiService from '../../../services/ApiService';
import "./personalData.css"

const PersonalData = (props) => {
    const apiService = ApiService.getInstance();
    const [formData, setFormData] = useState({
        firstName: props.userData.firstName,
        lastName: props.userData.lastName,
        genderDVID: props.userData.genderDVID,
        dateofbirdth: props.userData.dateOfBirdth,
        pesel: props.userData.pesel,
        street: props.userData.street,
        building: props.userData.building,
        flat: props.userData.flat,
        city: props.userData.city,
        postalCode: props.userData.postalCode,
        email: props.userData.email,
        phone: props.userData.phone,
        personalDataProcessingConsent: props.userData.personalDataProcessingConsent,
        //  
    });

    

    function changeBD(bd){
        if(bd != null){
        let date = bd.split(" ")[0].split("/"); 
        let correctData = date[1] + "-" + date[0] + "-" + date[2]
        return correctData}else{
            return ""
        }
    }
    return <>
    <div className='personalData_content'>
        <CustomInputValue  value={formData.firstName} size="big" title={"Imię"}></CustomInputValue>
        <CustomInputValue  value={formData.lastName} size="big" title={"Nazwisko"}></CustomInputValue>
        <div className='chooseConection'>
                <p>
                Płeć
                </p>
                <ChooseUserOption isChekcked={formData.genderDVID == 2} onCheck={(e)=>{}} label="Kobieta"></ChooseUserOption>
                <ChooseUserOption isChekcked={formData.genderDVID == 1} onCheck={(e)=>{}} label="Mężczyzna"></ChooseUserOption>
                <ChooseUserOption isChekcked={formData.genderDVID == 3} onCheck={(e)=>{}} label="Nie chcę podawać"></ChooseUserOption>
                
            </div>
        <CustomInputValue value={formData.pesel} size="big" title={"Pesel"}></CustomInputValue>
        <CustomInputValue value={changeBD(formData.dateofbirdth)} size="big" title={"Data urodzenia"}></CustomInputValue>
        <div className='rowInput'>
        <CustomInputValue value={formData.street} size="small" title={"Ulica"}></CustomInputValue>
        <CustomInputValue value={formData.building +"/"+ formData.flat} size="small" title={"Nr domu/Nr mieszkania"}></CustomInputValue>
        </div>
        <div className='rowInput'>
        <CustomInputValue value={formData.postalCode} size="small" title={"Kod pocztowy"}></CustomInputValue>
        <CustomInputValue value={formData.city} size="small" title={"Miejscowość"}></CustomInputValue>
        </div>
        <CustomInputValue value={formData.phone} size="big" title={"Nr telefonu"}></CustomInputValue>
       
    </div>
            
</>;
};

export default PersonalData;
